import { setMarkers } from '../markers'
import { routes, setRoutes } from './data/routes'
import { airports, setAirports } from './data/airports'
import filterVisibleMarkers from './filterVisibleMarkers'
import setLowestPrices from './setLowestPrices'
import matchIataWithAirportName from './matchIataWithAirportName'

export const getRoutesAndMarkersData = (opts, callBacks) => {
  $.getJSON(opts.dataPaths.baseData)
  .then(data => {
    matchIataWithAirportName(data.airports, data.journeys)
    setAirports(data.airports)
    setRoutes(data.journeys)

    const onlyVisibleMarkers = filterVisibleMarkers(data.airports, data.journeys)
    data.airports = setLowestPrices(onlyVisibleMarkers, data.journeys)

    setMarkers(data.airports)

    Object.keys(callBacks).forEach((key) => {
      if(typeof callBacks[key] !== 'undefined' && typeof callBacks[key] === 'function')
        callBacks[key](opts)
    })
  })
  .fail(err => {
    console.error('Error loading data', err)
  })
}



// WEBPACK FOOTER //
// ./app/utils/getRoutesAndMarkersData.js